<template>
  <div class="c-key-cpf">
    <p class="title">Confirme a chave PIX que será cadastrada</p>

    <div class="field-body column is-full">
      <div class="field">
        <div class="control">
          <label for="cpf">CPF: </label>
          <input
            :value="cpf"
            class="input has-value"
            placeholder="CPF"
            name="cpf"
            type="text"
            disabled
            autocomplete="off"
          />
          <i class="bar"></i>
          <p class="help is-error"></p>
        </div>
      </div>
    </div>
    <p class="another-key" @click="registerAnotherKey">
      Sua chave PIX não é um CPF? Utilizar outra chave
      <i class="fa fa-chevron-right"></i>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    cpf: {
      type: String,
      required: true,
    },
  },

  methods: {
    registerAnotherKey() {
      this.$emit('update:anotherKey', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-key-cpf {
  .title {
    margin-bottom: 40px;
    font-size: 20px;
    line-height: 100%;
    font-weight: bold;
    color: $gray-7;
  }

  .another-key {
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    line-height: 21.6px;
    color: $support;
    margin-bottom: 50px;
    i {
      margin-left: 4px;
      font-size: medium;
    }
  }

  input:disabled {
    color: $neutrallight !important;
    background-color: white;
    font-size: 32px;
    padding: 20px 0;
    font-weight: 700;
    line-height: 38.4px;
  }

  label {
    font-size: 14px;
    font-weight: 700;
    color: $gray-7;
    line-height: 16.8px;
  }

  .field-body {
    padding-left: 0;
  }

  .maintenance {
    margin: 16px 0 50px;
  }
}
</style>
